export default function isExternalIdentifierValid(
  ssn: string,
  country: string,
) {
  if (ssn == '') {
    return true;
  }
  if (country == 'fr') {
    return isValidFrenchSSN(ssn);
  }
  if (country == 'be') {
    return isValidBelgianSSN(ssn);
  }
  return false;
}

export function isValidFrenchSSN(ssn: string): boolean {
  const cleaned = ssn;

  if (!/^[12]\d{12}\d{2}$/.test(cleaned)) {
    return false;
  }

  const numberPart = cleaned.slice(0, 13);
  const key = Number(cleaned.slice(13, 15));

  const calculatedKey = 97 - (Number(numberPart) % 97);

  return calculatedKey === key;
}

export function isValidBelgianSSN(value: string): boolean {
  const niss = value;

  // Doit contenir exactement 11 chiffres
  if (!/^\d{11}$/.test(niss)) return false;

  const baseNumber = parseInt(niss.substring(0, 9), 10);
  const checkDigits = parseInt(niss.substring(9, 11), 10);

  // Calcul avant 2000
  const checksumBefore2000 = 97 - (baseNumber % 97);

  // Calcul après 2000
  const checksumAfter2000 = 97 - ((2000000000 + baseNumber) % 97);

  return (
    checkDigits === checksumBefore2000 || checkDigits === checksumAfter2000
  );
}
